export enum RouteName {
  login = 'login',
  authRoot = 'authRoot',
  dashboard = 'dashboard',
  codesRoot = 'codesRoot',
  codesRead = 'codesRead',
  codesCreate = 'codesCreate',
  subscriptionRoot = 'subscriptionRoot',
  subscriptionRead = 'subscriptionRead',
  subscriptionCreate = 'subscriptionCreate',
}
